// src/auth/TokenUtils.js
export const decodeToken = (token) => {
    try {
      return JSON.parse(atob(token.split('.')[1]));
    } catch {
      return null;
    }
  };
  
  export const getTokenExpiry = (token) => {
    const decoded = decodeToken(token);
    return decoded?.exp ? decoded.exp * 1000 : null;
  };
  
  export const isTokenExpired = (token) => {
    const expiry = getTokenExpiry(token);
    if (expiry === null || expiry === undefined) {
      return false;
    }
    return Date.now() >= expiry;
  };
export const willExpireSoon = (token, thresholdMs = 5 * 60 * 1000) => {
    const expiry = getTokenExpiry(token);
    return expiry && expiry - Date.now() <= thresholdMs;
  };
  